<template>
  <SliderLamar></SliderLamar>
  <p>
    El Laboratorio de Microfísica Atmosférica y Radiación (LAMAR) del IGP, tiene
    como objetivo mejorar la comprensión de los procesos físicos, dinámicos y
    microfísicos que afectan el clima de los Andes, con ello mejorar la
    capacidad de los modelos físico-matemáticos para la evaluación de los
    impactos futuros del cambio climático; así mismo, la información generada en
    LAMAR sirve para validar los productos obtenidos con técnicas de
    sensoramiento remoto.
  </p>
  <p>
    LAMAR fue implementado, sobre la base de la estación climatológica principal
    “Huayao", estación centenaria que se mantiene operando desde 1921, y cuenta
    con la serie climática más larga en los Andes peruanos. Desde el año 2011 se
    implementaron sofisticados instrumentos especializados, como son: un radar
    perfilador de vientos de capa límite, (2011), anemómetro sónico (2012), un
    radar perfilador de nubes y precipitación MIRA 35C (2014), fotómetro solar
    (??), higrómetro (2016), disdrómetro (2017), torre de gradiente (2018),
    estación BSRN (2018), entre otros.
  </p>
  <MapsLamar></MapsLamar>
</template>
<script>
import SliderLamar from "@/components/ui/molecules/SliderLamar.vue";
import MapsLamar from "@/components/ui/atoms/MapsLamar.vue";

export default {
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: { SliderLamar, MapsLamar },
};
</script>
